import React, { Component } from "react";

import PropsType from "prop-types";
import _ from "lodash";
import { Collapse } from "@mui/material";

import FItem from "../FItem";

import { Accessor } from "static";

class FGFold extends Component {
  static propTypes = {
    //data
    ischema: PropsType.object.isRequired,
    formValue: PropsType.object,
    addOns: PropsType.object,
  };

  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { ischema, formValue, preAccessor } = this.props;
    const { open } = this.state;
    if (!ischema) return;
    let controlV;
    let iname = ischema.control;
    if (!_.isEmpty(preAccessor)) {
      if (!_.isEmpty(ischema.control)) {
        iname = preAccessor + "." + ischema.control;
      } else {
        iname = preAccessor;
      }
    }

    if (ischema.controlFunc && _.isFunction(ischema.controlFunc)) {
      let v = Accessor.Get(formValue, iname);
      controlV = ischema.controlFunc(formValue, v);
    } else {
      controlV = Accessor.Get(formValue, iname);
    }

    if (ischema.inverse) {
      controlV = !controlV;
    }
    if (controlV !== open) {
      this.setState({
        open: controlV,
      });
    }
  }

  getFoldSchema = () => {
    const { ischema, formValue, addOns } = this.props;
    if (_.isFunction(ischema.fold)) {
      return ischema.fold(formValue, addOns);
    }
    return ischema.fold;
  };

  renderSchema() {
    let { ischema, ...other } = this.props;
    let foldSchema = this.getFoldSchema();
    return _.map(foldSchema, (o, i) => {
      return <FItem key={i} ischema={o} {...other} />;
    });
  }

  renderInside() {
    const { open } = this.state;
    return (
      <Collapse in={open} style={{ width: "100%" }}>
        {this.renderSchema()}
      </Collapse>
    );
  }

  render() {
    const { ischema } = this.props;
    if (!ischema) return null;

    return this.renderInside();
  }
}

export default FGFold;
